import * as React from 'react';
import { PDPPriceSection } from './PDPPriceSection.js';
import { useProductDetailContext } from '../../Context/ProductDetailContext.js';

const PDPPriceSectionContainer = ({ className , pricePerLiter  })=>{
    const { activeVariant  } = useProductDetailContext();
    const price = activeVariant.price;
    if (!price) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(PDPPriceSection, {
        className: className,
        originalPrice: price.originalPrice,
        discountedPrice: price.discountedPrice,
        discountDescription: activeVariant.discountText,
        discountBadge: activeVariant.discounted,
        bestPrice: activeVariant.bestPrice,
        perLiterPrice: pricePerLiter
    });
};

export { PDPPriceSectionContainer };
//# sourceMappingURL=PDPPriceSectionContainer.js.map
